/*
  state-class.js

  A small plugin to allow the model
  to dictate body state classes,
  e.g: hasNoNext

  The states should be stored in
  case of refresh.

  One or more states can be added with:
  setmetadata('state-class-add', 'state1|state2|etc...')

  One or more states can be removed by:
  setmetadata('state-class-remove', 'state1|state2|etc...')

  In order to prevent states from remaining after a
  change to new session (be it a new model or new case)
  I also included a check for that event.

  Author: Tim Bauwens
  Copyright: xxllnc 2021
*/

import { state } from "$json/lib/store";
import { has } from "$json/lib/functional";
import { getmetadata } from "$json/lib/getmetadata";

((doc, win, $) => {
  let currentSession;

  const pluginid = "p-state-title";

  const applystate = () => {
    // When called, run through the state and apply UI critical states.
    state.has(pluginid) &&
      [state.get(pluginid)].forEach(title => {
        [...document.querySelectorAll(`.bb-${pluginid}`)].forEach(
          n => (n.textContent = title)
        );
      });
  };

  $(doc).on("bb:stateChange", (e, data) => {
    applystate();
  });

  $(doc).on("bb:preHandleData", (e, data) => {
    // Check if the session has changed.
    if (has("groups")(data) && currentSession !== data.sessionid) {
      // This is a new session. Start fresh.
      currentSession = data.sessionid;
      state.set(pluginid, "");
      applystate();
    }

    if (has("groups")(data) && data.groups.length) {
      // Get metadata & states
      let md = getmetadata(data).props;
      let currentTitle = state.has(pluginid) ? state.get(pluginid) : "";
      // Maintain the list of added classes.
      if (md.has(pluginid)) {
        [md.get(pluginid)].forEach(title => {
          if (currentTitle !== title) {
            state.set(pluginid, title);
            applystate();
          }
        });
      }
    }
  });
})(document, window, jQuery);
